const RiskManagmentCounter = () => {
  return (
    <>
      <div className="rm-counter-area risk-bg-color-two pt-60 pb-120">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xxl-4">
              <h6 className="risk-sub-text fs-16 ff-risk-pri fw-700 mb-20">
                Fun Facts
              </h6>
              <h2 className="text-white fs-36 ff-risk-pri flh-44 fw-800 mb-20 fch-14">
                The Numbers tell Our Story
              </h2>
              <p className="text-white ff-dmsans fs-16 flh-24 mb-0">
                Far and wide, we’re known for our dedication to governance, risk
                compliance.
              </p>
            </div>
            <div className="col-xxl-7">
              <div className="row">
                <div className="col-lg-4">
                  <div className="risk-counter-item mt-20">
                    <h3 className="text-white fs-56 ff-dmsans fw-700">
                      <span className="counter">2</span>millions
                    </h3>
                    <p className="text-white ff-dmsans fs-16 flh-24 mb-0">
                      People and employees Worldwide
                    </p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="risk-counter-item risk-border-left risk-border-color pl-40 mt-20">
                    <h3 className="text-white fs-56 ff-dmsans fw-700">
                      <span className="counter">40</span>k+
                    </h3>
                    <p className="text-white ff-dmsans fs-16 flh-24 mb-0">
                      People and employees Worldwide
                    </p>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="risk-counter-item risk-border-left risk-border-color pl-40 mt-20">
                    <h3 className="text-white fs-56 ff-dmsans fw-700">
                      <span className="counter">90</span>+
                    </h3>
                    <p className="text-white ff-dmsans fs-16 flh-24 mb-0">
                      of Ethisphere’s World’s Most Ethical Companies
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiskManagmentCounter;
